function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dropdown from "semantic-ui-react/dist/es/modules/Dropdown/Dropdown.js";
import classnames from 'classnames';
import { some } from "../../../utils/some";
import { getIsInputValueReset } from "../../../utils/get-is-input-value-reset";
import { getHasErrorMessage } from "../../../utils/get-has-error-message";
import { Icon, ICON_NAMES } from "../../elements/Icon";
import { NO_RESULTS } from "../../../utils/default-strings";
import { getControlledInputValue } from "../../../utils/get-controlled-input-value";
import { getPropOnCondition } from "../../../utils/get-prop-on-condition";
import { ErrorMessage } from "../ErrorMessage";
import { getIsOpenAfterChange } from "./utils/getIsOpenAfterChange";
import { adaptOptions } from "./utils/adaptOptions";
import { getHasImages } from "./utils/getHasImages";
import { getIcon } from "./utils/getIcon";
export var Component = function (_PureComponent) {
  _inherits(Component, _PureComponent);

  var _super = _createSuper(Component);

  function Component() {
    var _this;

    _classCallCheck(this, Component);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isBlurred: true,
      isOpen: false,
      value: getControlledInputValue(_this.props.value, _this.props.initialValue)
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (_ref, _ref2) {
      var key = _ref.key;
      var value = _ref2.value;

      _this.setState({
        value: value,
        isOpen: getIsOpenAfterChange(key)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOpen", function (isOpen) {
      return _this.setState({
        isOpen: isOpen,
        isBlurred: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (isBlurred) {
      return _this.setState({
        isBlurred: isBlurred,
        isOpen: false
      });
    });

    return _this;
  }

  _createClass(Component, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps, previousState) {
      if (getIsInputValueReset(previousProps.value, this.props.value)) {
        this.setState({
          value: undefined
        });
        return;
      }

      var _this$state = this.state,
          value = _this$state.value,
          isBlurred = _this$state.isBlurred;
      var _this$props = this.props,
          name = _this$props.name,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          onFocus = _this$props.onFocus;

      if (previousProps.value !== this.props.value) {
        var _value = getControlledInputValue(this.props.value, this.props.initialValue, this.state.value);

        this.setState({
          value: _value
        });
        return;
      }

      if (previousState.value !== value) {
        onChange(name, value);
      }

      if (!previousState.isBlurred && isBlurred) {
        onBlur(name);
      }

      if (previousState.isBlurred && !isBlurred) {
        onFocus(name);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOpen = this.state.isOpen;
      var _this$props2 = this.props,
          getOptionsWithSearch = _this$props2.getOptionsWithSearch,
          error = _this$props2.error,
          icon = _this$props2.icon,
          isClearable = _this$props2.isClearable,
          isCompact = _this$props2.isCompact,
          isDisabled = _this$props2.isDisabled,
          isSearchable = _this$props2.isSearchable,
          isValid = _this$props2.isValid,
          noResultsText = _this$props2.noResultsText,
          label = _this$props2.label,
          options = _this$props2.options,
          willOpenAbove = _this$props2.willOpenAbove;
      var value = getControlledInputValue(this.props.value, this.props.initialValue, this.state.value);
      var hasImages = getHasImages(options);
      var adaptedOptions = adaptOptions(options, hasImages);
      var hasErrorMessage = getHasErrorMessage(error);
      return React.createElement("div", {
        className: classnames('dropdown-container', {
          'has-images': hasImages,
          'is-compact': isCompact,
          dirty: some(value) || some(this.props.initialValue || this.props.value),
          error: error,
          focus: isOpen,
          valid: isValid
        })
      }, hasErrorMessage && React.createElement(ErrorMessage, {
        errorMessage: error
      }), isValid && React.createElement(Icon, {
        color: "green",
        name: ICON_NAMES.CHECKMARK
      }), !hasImages && icon && React.createElement(Icon, {
        name: icon
      }), React.createElement(Dropdown, {
        clearable: isClearable,
        compact: isCompact,
        disabled: isDisabled || !adaptedOptions.length,
        icon: React.createElement(Icon, {
          name: getIcon(value, isClearable),
          size: getPropOnCondition('small', isCompact)
        }),
        noResultsMessage: noResultsText,
        onBlur: function onBlur() {
          return _this2.handleBlur(true);
        },
        onChange: this.handleChange,
        onClick: function onClick() {
          return _this2.handleOpen(!isOpen);
        },
        open: isOpen,
        options: adaptedOptions,
        placeholder: label,
        search: getOptionsWithSearch || isSearchable,
        selectOnBlur: false,
        selection: true,
        upward: willOpenAbove,
        value: value
      }));
    }
  }]);

  return Component;
}(PureComponent);
Component.displayName = 'Dropdown';
Component.defaultProps = {
  error: false,
  getOptionsWithSearch: null,
  icon: null,
  isClearable: true,
  isCompact: false,
  isDisabled: false,
  isSearchable: false,
  isValid: false,
  label: '',
  name: '',
  noResultsText: NO_RESULTS,
  onBlur: Function.prototype,
  onChange: Function.prototype,
  onFocus: Function.prototype,
  options: [],
  value: undefined,
  willOpenAbove: false,
  initialValue: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  getOptionsWithSearch: PropTypes.func,
  icon: PropTypes.string,
  initialValue: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  isClearable: PropTypes.bool,
  isCompact: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isSearchable: PropTypes.bool,
  isValid: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  noResultsText: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    content: PropTypes.node,
    imageSizes: PropTypes.string,
    imageSrcSet: PropTypes.string,
    imageUrl: PropTypes.string,
    indent: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
    label: PropTypes.string,
    text: PropTypes.node.isRequired,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
  })),
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),
  willOpenAbove: PropTypes.bool
} : {};